(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/utils.js'); 
(function(svs) {
  'use strict';

  svs.customer_service.utils = svs.customer_service.utils || {};

  svs.customer_service.utils.getFormData = function(formId) {
    var model = {};
    $('#' + formId)
      .find('.js-input[name]')
      .each(function() {
        var target = $(this);
        if (target.hasClass('js-input-int')) {
          if (target.attr('type') === 'radio') {
            if (target.is(':checked')) {
              model[this.name] = parseInt(this.value, 10);
            }
          } else {
            model[this.name] = parseInt(this.value, 10);
          }
        } else if (target.attr('type') === 'radio') {
          if (target.is(':checked')) {
            model[this.name] = this.value;
          }
        } else {
          model[this.name] = this.value;
        }
      });
    return model;
  };
  svs.customer_service.utils.showErrorMessage = function(err) {
    svs.events.publish('/loader/hide');
    if (err) {
      var error = JSON.parse(err.responseText).error;
      if (error) {
        switch (error.code) {
          case 10010:
          case 10020: 
            svs.components.formValidation.showErrorMessage('personalId', { message: 'Ogiltigt personnummer' });
            break;
          case 10150: 
            svs.components.formValidation.showErrorMessage('SSN', { message: 'Vi hittar ingen kund med detta personnummer' });
            break;
          case 10050: 
            svs.components.formValidation.showErrorMessage('email', { message: 'Felaktigt angiven e-postadress' });
            break;
          case 12410: 
            svs.components.formValidation.showErrorMessage('subject', { message: 'Vald kategori stöds inte, vänligen välj en annan.' });
            break;
          case 12500: 
            svs.components.formValidation.showErrorMessage('code', { message: 'Felaktig kod, försök igen eller beställ en ny i min profil.' });
            break;
          default:
            var dialog = new svs.components.dialog.Confirm({
              branding: svs.components.dialog.branding.TUR,
              type: svs.components.dialog.type.ERROR,
              title: 'Tekniskt fel',
              message: [
                {
                  type: svs.components.dialog.message.TEXT,
                  text: 'Kontakta kundservice: 0770 - 11 11 11'
                }
              ],
              actions: [
                {
                  title: 'OK'
                }
              ]
            });

            svs.components.dialog.api.add(dialog);
        }
      }
    }
  };
})(svs);

 })(window);